import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./layouts/Navbar";
import Footer from './layouts/Footer/Footer';
import Home from "./pages/Home/Home";
import Projects from "./pages/Projects/Projects";
import Contact from './pages/Contact/Contact';
import Careers from './pages/Careers/Careers';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminMedia from './pages/admin/AdminMedia';
import AdminMessages from './pages/admin/AdminMessages';
import ScrollToTop from './services/Scrolltop';
import useContent from './hooks/useContent';

function AppContent() {
  const { content, loading, error } = useContent();
  const location = useLocation();

  // Check if we're on an admin route
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
      <ScrollToTop />

      {/* Show Navbar and Footer only on non-admin routes */}
      {!isAdminRoute && content && (
        <Navbar
          logo={content.navbar?.logo}
          brandName={content.navbar?.brandName}
          links={content.navbar?.links}
          buttonText={content.navbar?.buttonText}
        />
      )}

      {/* Error banner (non-blocking) */}
      {error && !isAdminRoute && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          background: '#ff4444',
          color: 'white',
          padding: '10px',
          textAlign: 'center',
          zIndex: 9999
        }}>
          Failed to load content. Some features may not work correctly.
        </div>
      )}

      <Routes>
        <Route path="/" element={<Home content={content} loading={loading} />} />
        <Route path="/projects" element={<Projects content={content} loading={loading} />} />
        <Route path="/contact" element={<Contact content={content} loading={loading} />} />
        <Route path="/careers" element={<Careers content={content} loading={loading} />} />

        {/* Admin routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/media" element={<AdminMedia />} />
        <Route path="/admin/messages" element={<AdminMessages />} />
      </Routes>

      {!isAdminRoute && content && (
        <Footer
          logo={content.footer?.logo}
          brandName={content.footer?.brandName}
          quickLinks={content.footer?.quickLinks}
          contactInfo={content.footer?.contactInfo}
          contactPerson={content.footer?.contactPerson}
          copyright={content.footer?.copyright}
        />
      )}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
